import request from '@hb/request';
import { env } from '../util';
function authUrl() {
    switch (env()) {
        case 'fat':
            return 'https://fat-api.hellobike.com/auth';
        case 'uat':
            return 'https://uat-api.hellobike.com/auth';
        case 'pre':
            return 'https://pre-api.hellobike.com/auth';
        case 'pro':
            return 'https://api.hellobike.com/auth';
        default:
            return 'https://fat-api.hellobike.com/auth';
    }
}
function gatewayUrl() {
    switch (env()) {
        case 'fat':
            return 'https://fat-gwfinance.hellobike.com/api';
        case 'uat':
            return 'https://uat-gwfinance.hellobike.com/api';
        case 'pre':
            return 'https://pre-gwfinance.hellobike.com/api';
        case 'pro':
            return 'https://gwfinance.hellobike.com/api';
        default:
            return 'https://fat-gwfinance.hellobike.com/api';
    }
}
const authConfig = {
    baseURL: authUrl()
};
// 发送登录短信验证码
export const getLoginCode = (mobile, source, capText = '') => request.postGate('user.account.sendCodeV2', {
    mobile,
    source,
    capText
}, authConfig);
// 验证短信验证码登录
export const login = (mobile, code) => request.postGate('user.account.login', {
    mobile,
    code
}, authConfig);
// 根据哈啰用户token获取金融用户登录信息
export const getFinanceUser = (token, baseURL) => request.get('', {
    token,
    action: 'finance.user.info'
}, {
    baseURL: baseURL || gatewayUrl(),
    withCredentials: false,
    standardResponse: false,
    showLoading: undefined,
    showErrMsg: undefined
});
const CommonApi = {
    getLoginCode,
    login,
    getFinanceUser
};
export default CommonApi;
//# sourceMappingURL=api.js.map